import { render } from "./BaseDialogue.vue?vue&type=template&id=1abffe6e&scoped=true"
import script from "./BaseDialogue.vue?vue&type=script&lang=js"
export * from "./BaseDialogue.vue?vue&type=script&lang=js"

import "./BaseDialogue.vue?vue&type=style&index=0&id=1abffe6e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ACER\\Desktop\\Vue Course\\Main Course Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abffe6e"]])

export default __exports__